import {growthbookCacheAtom} from 'atoms/growthbook';
import {useAtomValue} from 'jotai';
import {NotFound} from 'pages/NotFound';
import {lazy, Suspense} from 'react';

import {AppsCatalog} from './AppsCatalog';
import {CreateApp} from './CreateApp';
import {UpdateApp} from './UpdateApp';

const AppStudio = lazy(() =>
  import('./studio/AppStudio').then((module) => ({default: module.AppStudio}))
);

const AppsFeatureRoute = ({children}: {children: React.ReactNode}) => {
  const {isAppBuilderPlatformEnabled} = useAtomValue(growthbookCacheAtom);

  return isAppBuilderPlatformEnabled ? children : <NotFound />;
};

export const AppsRoute: React.FC = () => (
  <AppsFeatureRoute>
    <AppsCatalog />
  </AppsFeatureRoute>
);

export const CreateAppRoute: React.FC = () => (
  <AppsFeatureRoute>
    <CreateApp />
  </AppsFeatureRoute>
);

export const UpdateAppRoute: React.FC = () => (
  <AppsFeatureRoute>
    <UpdateApp />
  </AppsFeatureRoute>
);

export const AppStudioRoute: React.FC = () => (
  <AppsFeatureRoute>
    <Suspense fallback={null}>
      <AppStudio />
    </Suspense>
  </AppsFeatureRoute>
);

const NovaBuilderLive = lazy(() => import('./builder/NovaBuilderLive'));

export const NovaBuilderRoute: React.FC = () => (
  <AppsFeatureRoute>
    <Suspense fallback={null}>
      <NovaBuilderLive />
    </Suspense>
  </AppsFeatureRoute>
);
